import React from "react"
import CustomPageHeader from "../../fragments/CustomPageHeader"

export default function AccountingRule({ children }) {
  return (
    <div>
      <CustomPageHeader icon='lock' text='Accounting rules' />
      { children }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Accounting/AccountingRules/index.js